import React, { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { saveAs } from "file-saver";

import PATH from "../../routes/RoutePath";
import dummyFile from "../../assets/img/placeholders/file-placeholder.png";
import { Link } from "react-router-dom";
const MyCollapse = (props: any) => {
  const { metaData, openCollapse, reportId } = props;
  const [urlsImg, setUrlsImg] = useState<any[]>([]);

  const imageOnErrorHandler = (event: any) => {
    event.currentTarget.src = dummyFile;
  };
  const getImgUrl = (urls: any[]) => {
    if (!urls) return null;
    var urlsTmp: any[] = [];
    urls.map((url) => {
      const urlTmp = url.slice(0, 5);
      if (urlTmp === "https") {
        urlsTmp.push(url);
      } else {
        const storage = getStorage();
        const imgRef = ref(storage, url);

        getDownloadURL(imgRef)
          .then((URL) => {
            urlsTmp.push(URL);
          })
          .catch(() => {});
      }
      setUrlsImg(urlsTmp);
    });
  };
  useEffect(() => {
    metaData?.evidenceFile && getImgUrl([metaData?.evidenceFile]);
    metaData?.evidenceFiles && getImgUrl(metaData?.evidenceFiles);
  }, [metaData?.evidenceFile, metaData?.evidenceFiles]);
  return (
    <Collapse in={openCollapse}>
      <div className="mt-4">
        {metaData?.reason && (
          <p>
            Reason : <b>{metaData?.reason ?? ""}</b>
          </p>
        )}
        {urlsImg && urlsImg?.length > 0 && (
          <>
            <p>Evidence :</p>
            {urlsImg.map((urlImg: any, i: number) => (
              <img
                className="cursor-pointer"
                src={
                  // isImage(metaData?.evidenceFiles[i]) ? urlImg : dummyFile
                  urlImg
                }
                alt={"Evidence"}
                style={{
                  width: "150px",
                  marginRight: "15px",
                  marginBottom: "15px",
                }}
                onClick={() => saveAs(urlImg, "Evidence File.jpg")}
                onError={imageOnErrorHandler}
              />
            ))}
          </>
        )}

        {metaData?.reportIds && metaData.reportIds.length > 0 && (
          <span>
            Report ID{metaData?.reportIds.length > 1 ? "s" : ""}:{" "}
            {metaData?.reportIds.map((item: any) => (
              <Link
                to={PATH.REPORTS.REPORT_DETAILS + item?.id}
                style={{ marginRight: "8px" }}>
                {item?.reportId}{" "}
              </Link>
            ))}
          </span>
        )}
        {!metaData?.reportIds && reportId && (
          <span className="">
            Report ID:{" "}
            <Link to={PATH.REPORTS.REPORT_DETAILS + reportId?.id}>
              {reportId?.reportId}
            </Link>
          </span>
        )}
        {/* <span className="mx-4 ml-0">
								<Link to={PATH.REPORTS.REPORT_DETAILS + id}>Report 2</Link>
							</span> */}
      </div>
    </Collapse>
  );
};

export default MyCollapse;
